type CurrencyOptions = {
  currencyCode?: Intl.NumberFormatOptions['currency'];
  maximumFractionDigits?: number;
};

export const formatCurrency = (
  value: number | string,
  { currencyCode = 'GBP', maximumFractionDigits = 2 }: CurrencyOptions = {}
) =>
  new Intl.NumberFormat('en-UK', {
    currency: currencyCode,
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: 0,
    style: 'currency',
  }).format(Number(value));
